<template>
    <cv-modal @check="check" @hide="clear" :visible.sync="visible" title="设置" c="modal default medium">
        <cv-form label="显示类型" :labelWidth="4" c="form default medium distant-y">
            <cv-select v-model="setting.show" :options="enumsShows" c="select default medium"></cv-select>
        </cv-form>
        <cv-button @click="toCapital" c="link primary mini distant-y">跳转到【记账管理】</cv-button>
    </cv-modal>
</template>

<script>
    import Storage from "../../lib/storage.js";
    import Consts from "../../js/consts.js";
    
    export default {
        name: "ModalSetting",
        data() {
            return {
                visible: false,
                setting: {
                    show: "ALL"
                },
                enums: {
                    shows: {
                        ALL: {
                            text: "所有",
                            filter: x => x
                        },
                        HIGH: {
                            text: "高风险",
                            filter: x => x.risk == "HIGH" && x.state == "ACTIVE"
                        },
                        MIDDLE: {
                            text: "中风险",
                            filter: x => x.risk == "MIDDLE" && x.state == "ACTIVE"
                        },
                        LOW: {
                            text: "低风险",
                            filter: x => x.risk == "LOW" && x.state == "ACTIVE"
                        },
                        ACTIVE: {
                            text: "未归档",
                            filter: x => x.state == "ACTIVE"
                        },
                        ARCHIVED: {
                            text: "归档",
                            filter: x => x.state == "ARCHIVED"
                        }
                    }
                }
            }
        },
        computed: {
            enumsShows() {
                let enums = [];
                for (let key in this.enums.shows) {
                    let value = this.enums.shows[key];
                    enums.push({
                        id: key,
                        name: value.text
                    })
                }
                return enums;
            }
        },
        mounted() {
            let savedSetting = Storage.getLocal(Consts.STORAGE_NAME_SETTING);
            if (!savedSetting) {
                return;
            }
            this.setting.show = savedSetting.show;
            this.$emit("changeSetting", this.setting);
        },
        methods: {
            show(setting) {
                if (setting) {
                    this.setting.show = setting;
                }
                this.visible = true;
            },
            hide() {
                this.visible = false;
                this.clear();
            },
            clear() {
            },
            check() {
                Storage.setLocal(Consts.STORAGE_NAME_SETTING, this.setting);
                this.$emit("changeSetting", this.setting);
                this.hide();
            },
            toCapital() {
                window.location.href = "capital-m.html"
            }
        }
    }
</script>

<style scoped lang="scss">

</style>